import PropTypes from 'prop-types';

import React from 'react';

import IconBlockType from '../ui/IconBlockType';

import ListItem from './ListItem';
import Item from './Item';

class EditorAddItem extends React.PureComponent {
  state = {
    hover: false,
  }

  handleClick = () => {
    this.props.onItemClick(this.props.id, this.props.index);
  }

  handleMouseEnter = () => { this.setState({ hover: true }); }

  handleMouseLeave = () => { this.setState({ hover: false }); }

  render() {
    return (
      <ListItem>
        <Item
          title={this.props.title}
          disabled={this.props.disabled}
          onClick={this.handleClick}
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
        >
          <IconBlockType type={this.props.id} bold={this.state.hover} />

          <div style={{ marginTop: '9px' }}>{this.props.title}</div>
        </Item>
      </ListItem>
    );
  }
}

EditorAddItem.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  disabled: PropTypes.bool,
  index: PropTypes.number,
  onItemClick: PropTypes.func,
};

export default EditorAddItem;
